import { memo } from "react";
import { useChatSession } from "../hooks/useChatSession";
import ChatAccessDenied from "./ChatAccessDenied";
import ChatComposer from "./ChatComposer";
import ChatHeader from "./ChatHeader";
import ChatMessagesArea from "./ChatMessagesArea";
import ChatThreadsPanel from "./ChatThreadsPanel";

const Chat = ({ setOpen, setBigWindow }) => {
  const session = useChatSession({ historyMode: "overlay" });

  if (!session.hasViewPermission) {
    return <ChatAccessDenied onClose={() => setOpen(false)} />;
  }

  return (
    <section className="chat-container w-[92vw] sm:w-[432px] h-[550px] bg-surface rounded-[18px] chat-sh overflow-hidden flex flex-col relative animate-fade-in border border-border-light">
      <ChatHeader
        t={session.t}
        variant="compact"
        isHistoryOpen={session.isHistoryOpen}
        onNewChat={session.handleNewChat}
        onToggleHistory={session.toggleHistory}
        onExpand={() => setBigWindow(true)}
        onClose={() => setOpen(false)}
      />

      <div className="flex-1 flex flex-col relative overflow-hidden bg-surface-muted">
        <ChatThreadsPanel
          variant="overlay"
          isOpen={session.isHistoryOpen}
          onClose={() => session.setIsHistoryOpen(false)}
          onCloseChat={() => setOpen(false)}
          searchQuery={session.searchQuery}
          onSearchChange={session.setSearchQuery}
          groupedThreads={session.groupedThreads}
          activeThreadId={session.activeThreadId}
          threadsFetching={session.threadsFetching}
          threadsLoading={session.threadsLoading}
          threadsPage={session.threadsPage}
          threadsContainerRef={session.threadsContainerRef}
          onThreadsScroll={session.handleThreadsScroll}
          onSelectThread={session.handleSelectThread}
          onCopyThread={session.handleCopyThread}
          onDeleteThread={session.handleDeleteThread}
          getThreadUuid={session.getThreadUuid}
        />

        <ChatMessagesArea
          t={session.t}
          variant="compact"
          messages={session.messages}
          loading={session.loading}
          loadingMore={session.loadingMore}
          fetchLoading={session.fetchLoading}
          isFetching={session.isFetching}
          hasPromptPermission={session.hasPromptPermission}
          messagesContainerRef={session.messagesContainerRef}
          onScroll={session.handleScroll}
          onSuggestionClick={session.handleSuggestionClick}
          messageTextClassName="chat-message-text"
        />

        <ChatComposer
          t={session.t}
          variant="compact"
          inputValue={session.inputValue}
          onInputChange={session.setInputValue}
          onKeyDown={session.handleKeyPress}
          onSend={() => session.handleSendMessage()}
          onFileSelect={session.handleFileSelect}
          onFileChange={session.handleFileChange}
          onRemoveFile={session.handleRemoveFile}
          fileInputRef={session.fileInputRef}
          selectedFile={session.selectedFile}
          loading={session.loading}
          hasPromptPermission={session.hasPromptPermission}
        />
      </div>
    </section>
  );
};

export default memo(Chat);
